import { transparentize } from 'polished';
import styled, { css } from 'styled-components';
import { StyledLink, StyledLinkProps } from './StyledLink';

export function styledCTALink({ linkColor }: StyledLinkProps) {
    return css`
        border-color: ${linkColor !== 'currentColor'
            ? transparentize(1, linkColor)
            : 'transparent'};
        border-bottom-width: 4px;
        &:link,
        &:visited {
            border-color: ${linkColor !== 'currentColor'
                ? transparentize(1, linkColor)
                : 'transparent'};
        }
        &:hover,
        &:focus {
            border-color: ${linkColor !== 'currentColor' ? linkColor : 'currentColor'};
        }
    `;
}
export const StyledCTALink = styled(StyledLink)(styledCTALink);
